import React from 'react';
import BrandingFooter from '../common/BrandingFooter';
import TeamBadge, { pickTeamLogo } from '../common/TeamBadge';
import FormPills from '../common/FormPills';

export default function FormGuide({
  showBranding = false,
  competitionLabel = 'Premier League',
  formRows = [],
}) {
  return (
    <div style={{ background: 'var(--sw-bg)', color: 'var(--sw-text)' }}>
      <div
        className="px-4 py-2 text-xs font-bold uppercase tracking-wide border-b"
        style={{ borderColor: 'var(--sw-border)', color: 'var(--sw-muted)' }}
      >
        {competitionLabel} — Form
      </div>
      <div className="p-3 sw-league-table">
        {formRows.length ? (
          <table className="w-full text-sm border-collapse">
            <thead>
              <tr
                className="text-left text-[10px] font-bold uppercase tracking-wider"
                style={{ color: 'var(--sw-muted)', borderBottom: '1px solid var(--sw-table-border)' }}
              >
                <th className="py-2 pr-1 w-9 text-center">#</th>
                <th className="py-2 pl-1">Team</th>
                <th className="py-2 px-1 text-center w-9 font-bold">PTS</th>
                <th className="py-2 pl-2 text-right">Form</th>
              </tr>
            </thead>
            <tbody>
              {formRows.map((r, i) => (
                <tr
                  key={`${r.position}-${r.team}`}
                  style={{
                    background: i % 2 === 0 ? 'var(--sw-table-row)' : 'var(--sw-table-row-alt)',
                  }}
                >
                  <td className="py-2.5 text-center font-semibold tabular-nums text-sm">{r.position}</td>
                  <td className="py-2.5 pr-2">
                    <span className="flex items-center gap-2 min-w-0">
                      <TeamBadge name={r.team} logoUrl={pickTeamLogo(r)} size={20} />
                      <span className="font-medium truncate">{r.team}</span>
                    </span>
                  </td>
                  <td className="py-2.5 text-center font-bold tabular-nums">{r.points}</td>
                  <td className="py-2.5 pr-1 text-right">
                    <FormPills form={r.form} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="text-center text-xs py-6" style={{ color: 'var(--sw-muted)' }}>
            Form data not available for this competition.
          </p>
        )}
      </div>
      {showBranding && <BrandingFooter />}
    </div>
  );
}
